// Region / currency selector: submit the localization form as soon as a country is picked.
document.addEventListener('change', function (event) {
  var select = event.target.closest && event.target.closest('[data-localization-select]');
  if (select && select.form) select.form.submit();
});

// Cookie notice: show once, remember the dismissal on this device.
(function () {
  var KEY = 'tar-cookie-note';
  function init() {
    var note = document.querySelector('[data-cookie-note]');
    if (!note) return;
    var seen = false;
    try { seen = !!window.localStorage.getItem(KEY); } catch (e) { /* storage blocked: just show it */ }
    if (!seen) note.hidden = false;
    note.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cookie-note-close]')) return;
      note.hidden = true;
      try { window.localStorage.setItem(KEY, '1'); } catch (err) { /* ignore */ }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
